export default __webpack_public_path__ + "static/media/1-instru.941c7fa1.png";